import { cascadeEval } from 'utils/conditions';
import { differenceInDays } from 'utils/date';

export function getTaskDaysLeft(expectedDate?: string) {
  if (!expectedDate) return 0;

  return differenceInDays(new Date(expectedDate), new Date());
}

export function getTaskDateColor(expectedDate?: string) {
  if (!expectedDate) return '';

  const daysLeft = getTaskDaysLeft(expectedDate);

  const color = cascadeEval([
    { is: daysLeft > 0, then: 'muted-foreground' },
    { is: daysLeft === 0, then: '#FFBF00' },
    { is: true, then: '#F3003A' },
  ]);

  return color;
}
